import React from 'react'


const WelcomeScreens = () => {
    return ( <h1>here is the welcome screen</h1> );
}
 
export default WelcomeScreens;